// Breakpoint definitions aligned with the SCSS setup
export const BP_MOBILE = 480;
export const BP_TABLET = 768;
export const BP_DESKTOP = 1024;
export const BP_WIDE = 1200;

// Global key variables
export const KEY_ESC = ["Escape", "Esc"]; // Esc for IE/Edge
export const KEY_ENTER = "Enter";
export const KEY_TAB = "Tab";
export const KEY_SHIFT = "Shift";

// Base elements for reference
export const HTML = document.querySelector("html");
export const BODY = document.body;

// Other global variables
export let isAnimationOk = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;

// Keep the last focused element here - to improve tab order if needed
export let lastFocused = null;

// Global spacers (in px) - aligned with the SCSS setup
export const SPACER_S = 12;
export const SPACER_M = 24;
export const SPACER_L = 48;